<template>
  <div class="panel panel-padding">
    <div class="panel-wrap-warrant">
      <div class="warrant-centent" style="padding: 20px 0px">
        <!--	时间选择-->
        <div class="table-search">
          <el-form :inline="true" class="input-custom input-custom-flex-none">
            <div class="table-search-btn flex-none">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-search"
                style="width: 80px; margin-right: 10px"
                @click="handleSearchClick"
                >查询</el-button
              >
              <el-button
                type="primary"
                size="mini"
                style="width: 80px; margin-right: 10px"
                @click="handleExportClick"
                >{{ search.cwstatus == 0 ? "对账" : "导出" }}</el-button
              >
            </div>
            <div class="table-search-wrap">
              <el-form-item label="快速查询">
                <el-input
                  v-model="search.keyword"
                  size="mini"
                  style="width: 200px; margin-left: 10px"
                  placeholder="服务器 / IP / 订单号 / 支付单号"
                ></el-input>
              </el-form-item>
              <el-form-item label="订单类型">
                <el-select
                  v-model="search.orderType"
                  placeholder="请选择"
                  size="mini"
                  style="width: 120px; margin-left: 10px"
                >
                  <el-option label="全部" :value="0"></el-option>
                  <el-option label="车辆授权" :value="1"></el-option>
                  <el-option label="车辆续费" :value="2"></el-option>
                  <el-option label="企业短信" :value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="对账状态">
                <el-select
                  v-model="search.cwstatus"
                  placeholder="请选择"
                  size="mini"
                  style="width: 120px; margin-left: 10px"
                >
                  <el-option label="全部" :value="-1"></el-option>
                  <el-option label="已对账" :value="1"></el-option>
                  <el-option label="未对账" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="支付金额">
                <el-input
                  v-model="search.payMoney"
                  size="mini"
                  style="width: 120px; margin-left: 10px"
                ></el-input>
              </el-form-item>
              <el-form-item label="支付时间">
                <el-date-picker
                  style="width: 180px; margin-left: 10px"
                  v-model="search.payBtime"
                  type="datetime"
                  placeholder=""
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="mini"
                ></el-date-picker>

                <span>&nbsp;&nbsp;~</span>
                <el-date-picker
                  style="width: 180px; margin-left: 10px"
                  v-model="search.payEtime"
                  type="datetime"
                  placeholder=""
                  value-format="yyyy-MM-dd HH:mm:ss"
                  size="mini"
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-form>
        </div>

        <div class="table">
          <div class="table-list" style="margin: 20px 10px">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              size="mini"
              border
              stripe
              style="width: 100%"
            >
              <el-table-column
                fixed="left"
                label="服务器名称"
                min-width="180"
                align="center"
                :show-overflow-tooltip="true"
                prop="company"
              ></el-table-column>
              <el-table-column
                label="服务器IP"
                min-width="120"
                align="center"
                :show-overflow-tooltip="true"
                prop="ip"
              ></el-table-column>
              <el-table-column
                label="订单号"
                min-width="180"
                align="center"
                :show-overflow-tooltip="true"
                prop="orderid"
              >
              </el-table-column>
              <el-table-column
                label="订单类型"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  {{ scope.row.orderType | orderTypeFormat }}
                </template>
              </el-table-column>
              <el-table-column
                prop="count"
                label="数量"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="payMoney"
                label="支付金额"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="clientName"
                label="客户名称"
                min-width="140"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="payTime"
                label="支付时间"
                min-width="140"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="xmoth"
                label="续费时长(月)"
                min-width="100"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="payType"
                label="支付方式"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  {{ scope.row.payType | payTypeFormat }}
                </template>
              </el-table-column>
              <el-table-column
                prop="payAccount"
                label="支付账号"
                min-width="120"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="payOrderid"
                label="支付单号"
                min-width="220"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                label="对账状态"
                min-width="80"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot-scope="scope">
                  {{ scope.row.cwstatus | cwStatusFormat }}
                </template>
              </el-table-column>
              <el-table-column
                prop="cworderid"
                label="对账批次"
                min-width="180"
                align="center"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                min-width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="option-cell">
                    <el-button
                      style="font-size: 12px"
                      @click="handleReplyClick(scope.row)"
                      >详情</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handlePageChange"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="search.size"
              :current-page="search.page"
              layout="total, sizes, prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- 弹窗 -->
      <el-dialog
        title="订单详情"
        :visible.sync="orderInfoDialog"
        class="dialogform cheliangXiangqing-dialog"
        width="700px"
        :close-on-click-modal="false"
      >
        <div class="cheliang-xiangqing">
          <!-- 基础信息 -->
          <div class="cheliang-xiangqing-list">
            <dl>
              <dt>服务器名称：</dt>
              <dd>{{ orderInfo.company }}</dd>
            </dl>
            <dl>
              <dt>服务器IP：</dt>
              <dd>{{ orderInfo.ip }}</dd>
            </dl>
            <dl>
              <dt>客户名称：</dt>
              <dd>{{ orderInfo.clientName }}</dd>
            </dl>
            <dl>
              <dt>操作人：</dt>
              <dd>{{ orderInfo.userName }}</dd>
            </dl>
            <dl>
              <dt>订单号：</dt>
              <dd>{{ orderInfo.orderid }}</dd>
            </dl>
            <dl>
              <dt>订单类型：</dt>
              <dd>{{ orderInfo.orderType | orderTypeFormat }}</dd>
            </dl>
            <dl>
              <dt>支付单号：</dt>
              <dd>{{ orderInfo.payOrderid }}</dd>
            </dl>
            <dl>
              <dt>支付时间：</dt>
              <dd>{{ orderInfo.payTime }}</dd>
            </dl>
            <dl>
              <dt>支付方式：</dt>
              <dd>{{ orderInfo.payType | payTypeFormat }}</dd>
            </dl>
            <dl>
              <dt>支付金额：</dt>
              <dd>{{ orderInfo.payMoney }}</dd>
            </dl>
          </div>
          <!-- 基础信息 end-->
        </div>
      </el-dialog>
      <!-- 弹窗 end-->
    </div>
  </div>
</template>
<script>
import { buyList, getUser } from "@/api/pay/bill";
import { getDateBefore } from "@/utils/common";
import { downloadFile } from "@/utils/download";
export default {
  data() {
    return {
      search: {
        orderid: "",
        keyword: "",
        orderType: 0,
        cwstatus: -1,
        payMoney: "",
        payBtime: null,
        payEtime: null,
        page: 1,
        size: 10,
      },
      tableData: [],
      total: 0,
      orderInfoDialog: false,
      orderInfo: {},
    };
  },
  filters: {
    payTypeFormat(type) {
      if (type == 0) {
        return "余额";
      }
      if (type == 1) {
        return "支付宝";
      }
      if (type == 2) {
        return "微信";
      }
      if (type == 7) {
        return "赠送";
      }
      return "其他";
    },
    orderTypeFormat(type) {
      if (type == 1) {
        return "车辆授权";
      }
      if (type == 2) {
        return "车辆续费";
      }
      if (type == 3) {
        return "企业短信";
      }
      return "其他";
    },
    cwStatusFormat(type) {
      if (type == 1) {
        return "已对账";
      }
      if (type == 0) {
        return "未对账";
      }
      return "其他";
    },
  },
  created() {},
  mounted() {
    this.search.payBtime = getDateBefore(30) + " 00:00:00";
    this.loadData();
  },
  methods: {
    loadData() {
      let params = Object.assign({}, this.search);
      buyList(params).then((res) => {
        this.tableData = res.data.data.pageList;
        this.total = res.data.data.total;
      });
    },
    handleSearchClick() {
      this.search.pageNum = 1;
      this.loadData();
    },
    handlePageChange(page) {
      this.search.pageNum = page;
      this.loadData();
    },
    handleSizeChange(size) {
      this.search.pageSize = size;
      this.search.pageNum = 1;
      this.loadData();
    },
    //   工单处理
    handleReplyClick(row) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      getUser({
        serverId: row.serverid,
        clientId: row.clientid,
        userId: row.userid,
      }).then((res) => {
        loading.close();
        let data = res.data.data;
        this.orderInfo = Object.assign({}, row);
        if (data != null) {
          this.orderInfo.userName = data.userName;
          this.orderInfo.clientName = data.clientName;
        }
        this.orderInfoDialog = true;
      });
    },
    handleExportClick() {
      if (this.search.cwstatus == 0) {
        this.$prompt(
          "请填写对账密码（对账文件仅生成一次，请保管好对账文件）",
          "导出对账文件",
          {
            confirmButtonText: "导出",
            cancelButtonText: "取消",
          }
        )
          .then(({ value }) => {
            if (value != "128") {
              this.$message.error("密码错误");
              return;
            }
            downloadFile("/video-pay/bill/export", this.search);
            this.loadData();
          })
          .catch(() => {});
      } else {
        downloadFile("/video-pay/bill/export", this.search);
      }
    },
  },
};
</script>

<style>
</style>